import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const rolGuardAdmin: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const userData = authService.getUser()
  if (!userData.token){
    router.navigate(["auth/login"]);
    return false
  }
   if( userData.rol === 'admin' ) {
    return true;
  } else{
    if(userData.rol === 'cliente'){ router.navigate(["client/home/dashboard"]);}
    if(userData.rol === 'monitorista'){router.navigate(["monitorist/home"]);}
    return false
  }
};

